import styled from 'styled-components';
import { transparentize } from 'polished';

import { ButtonBase } from 'components/Button/styles';

export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;

  >nav{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 10px;
    >button{
      width: 15rem;
      caret-color: transparent;
      svg{
        margin-right: 10px;
      }
    }
    >div{
      width: 15rem;
    }
  }
`;

export const Header = styled.div`
  flex-grow: auto;
  display: flex;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  ${ButtonBase} {
    margin: 0 10px 0 0 !important;
    min-width: 170px !important;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }
    }
  }
`;
